/**
 * Removes trailing slashes from a URL pathname.
 *
 * @param pathname - The URL pathname to process.
 * @returns The pathname without trailing slashes.
 */
export default function removeTrailingSlashes(pathname: string): string {
	// if (pathname === "/") {
	// 	return pathname;
	// }
	return pathname.replace(/\/+$/, "");
}
